<template>
  <span class="client-nav-wrapper">
    <el-select popper-class="clientNavSelectionOptions" v-if="clients.length > 1" class="clientNavSelection" :default-first-option="true" style="width: 100px; margin: -7px 0px 0px 0px;" size="mini" filterable v-model="currentClientComputed" :filter-method="clientNumberFilter">
      <div style="width: 570px; padding: 2px 15px 0px 15px; font-size: 14px;position: sticky;top: 0;height: 20px;background: #ffffff; z-index: 999;">
        <div style="float: left; width: 20%; text-align: left; border-bottom: 1px solid #ccc;">
          Service
        </div>
        <div style="float: left;width: 20%;text-align: left; border-bottom: 1px solid #ccc;">
          Client Number
        </div>
        <div style="float: left;width: 60%;text-align: left; border-bottom: 1px solid #ccc;">
          Client Name
        </div>
      </div>
      <el-option v-for="client in localClients" :key="client.clientNumber" :label="client.clientNumber" :value="client.clientNumber">
        <div style="width: 100%;">
          <div style="float: left; width: 20%; text-align: left;" v-html="client.revenueCenter ? client.revenueCenter : `<small><i>  &ltNot Specified&gt </i></small>`"></div>
          <div style="float: left;width: 20%;text-align: left;" v-html="client.clientNumber ? client.clientNumber : `<small><i>  &ltNot Specified&gt </i></small>`"></div>
          <div style="float: left;width: 60%;text-align: left;" v-html="client.clientName ? client.clientName : `<small><i>  &ltNot Specified&gt </i></small>`"></div>
        </div>
      </el-option>
    </el-select>
    <div v-else class="client-number">{{ currentClient }}</div>
    <div class="client-name" :class="clients.length > 1 ? 'multiClient' : 'singleClient'">{{ currentClientName }}</div>
  </span>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'

export default {
  name: 'clientNavSelector',
  mixins: [HiaAuthorization],
  props: {},
  data() {
    return {
      filterClient: '',
      options: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value: '',
      localClients: []
    }
  },
  methods: {
    ...mapMutations('user/', ['SET_USER', 'SET_CURRENT_CLIENT', 'SET_CURRENT_CLIENT_BY_ID']),
    ...mapMutations('dashboard/', ['CLEAR_REVIEW_DASHBOARD']),
    ...mapMutations('home/', ['SET_CLIENT_NAV_SELECTION']),
    initialize() {
      this.localClients = JSON.parse(JSON.stringify(this.clients))
    },
    handleClick() {
      this.$router.push(`/`)
    },
    handleVisChange(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.filterClient.focus()
        })
      } else {
        this.filterClient = ''
      }
    },
    handleCurrentChange(val) {
      this.SET_CLIENT_NAV_SELECTION(val.clientNumber)
    },
    clientNumberFilter(query) {
      this.localClients = this.clients.filter(x => {
        return query.length > 5 ? x.clientName.toLowerCase().indexOf(query.toLowerCase()) > -1 : x.clientNumber.toLowerCase().substring(0, query.length) === query.toLowerCase()
      })
    }
  },
  created: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['user', 'currentClient', 'currentClientId', 'currentClientName', 'clients']),
    clientTableData() {
      let data = this.filterClient.length ? this.clients.filter(f => f.clientNumber.toLowerCase().includes(this.filterClient.toLowerCase())) : this.clients
      return data
    },
    currentClientComputed: {
      get: function() {
        return this.currentClient
      },
      set: function(newVal) {
        this.SET_CLIENT_NAV_SELECTION(newVal)
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.clientNavSelectorTable >>> .caret-wrapper {
  display: none;
}

.clientNavSelectorButton >>> button:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.clientNavSelectorButton >>> button:last-child {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.clientNavSelectorButton >>> .el-dropdown__icon {
  font-size: 14px;
}

.clientNavSelection >>> input {
  border-radius: 30px;
}

.clientNavSelection >>> div.el-input > span.el-input__suffix::before {
  content: '';
  position: absolute;
  display: block;
  width: 1px;
  top: 5px;
  bottom: 5px;
  left: 0;
  background: rgba(220, 223, 230, 0.5);
}

.client-nav-wrapper {
  position: relative;
  display: inline-block;
}

.client-number {
  font-weight: bold;
  display: inline-block;
}

.client-name {
  position: absolute;
  top: 100%;
  margin-top: 4px;
  font-size: 14px;
  color: #909399;
  font-weight: 400;
  white-space: nowrap;
}
</style>

<style>
.clientNavSelectionOptions div.el-scrollbar {
  width: 600px !important;
}
</style>
